import { render, staticRenderFns } from "./EmpleadoDashboard.vue?vue&type=template&id=2559f5c2&scoped=true"
import script from "./EmpleadoDashboard.vue?vue&type=script&lang=js"
export * from "./EmpleadoDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmpleadoDashboard.vue?vue&type=style&index=0&id=2559f5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559f5c2",
  null
  
)

export default component.exports